import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

const BASE = `${config.API_URL}Beacon4Blended`;

// ── Filters ───────────────────────────────────────────────────────────────────

export const GetBeacon4SidePolygons = () =>
	AxiosRequest({
		method: 'GET',
		url:    `${BASE}/GetSidePolygons`,
	});

// ── KPI Config ────────────────────────────────────────────────────────────────

export const GetBeacon4KpiConfig = (tech) =>
	AxiosRequest({
		method: 'GET',
		url:    `${BASE}/GetKpiConfig`,
		params: { tech },
	});

// ── KPI Series (single KPI, one tech) ────────────────────────────────────────

export const GetBeacon4KpiSeries = (params) =>
	AxiosRequest({
		method: 'GET',
		url:    `${BASE}/GetKpiSeries`,
		params,
	});
// params: { tech, kpiKey, dateFrom, dateTo, aggregation, side?, polygon?, jvId? }

// ── Blended summary cards ─────────────────────────────────────────────────────

export const GetBeacon4BlendedSummary = (params) =>
	AxiosRequest({
		method: 'GET',
		url:    `${BASE}/GetBlendedSummary`,
		params,
	});

// ── Blended chart series ──────────────────────────────────────────────────────

export const GetBeacon4BlendedSeries = (data) =>
	AxiosRequest({
		method: 'POST',
		url:    `${BASE}/GetBlendedSeries`,
		data,
	});

// params: { kpiKey, dateFrom, dateTo, aggregation, side?, polygon?, jvId? }

// ── RAG Thresholds ────────────────────────────────────────────────────────────
export const GetBeacon4RagThresholds = (data) =>
	AxiosRequest({
		method: 'POST',
		url:    `${BASE}/GetRagThresholds`,
		data,
	});